import type { TriggerRow } from '../../automationstudio/framework';

type Props = { triggers?: TriggerRow[] };

export function TriggerEnginePanel({ triggers = [] }: Props) {
  return (
    <div className="space-y-2">
      {triggers.map((t) => (
        <div key={t.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{t.name}</p>
            <p className="mt-0.5 text-xs text-slate-500">{t.type}</p>
          </div>
          <div className="shrink-0 text-right">
            <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{t.events.toLocaleString()}</p>
            <p className="text-xs text-success-600">{t.status}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
